<template>
  <div>
    <h3 class="luci-subtitle">Change order</h3>

    <p class="luci-text">Please select a Category and Territory to view ordered games.</p>
    <p class="luci-text">To change the order of the currently 'Ordered Games', please drag and drop a game to the correct position.</p>
    <p class="luci-text">To add a new game to the ordered list, please drag and drop a game from the 'All Games' list.</p>

    <luci-select :config="categories" @change="changeCategory($event)" :value="selectedCategory"></luci-select>
    <luci-select :config="territories" @change="changeTerritory($event)" :value="selectedTerritory"></luci-select>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <v-layout wrap>
      <v-flex md6 pr-4>
        <div class="list-group-header" data-test-key="ordered-games-title">Ordered Games</div>
        <div v-if="isLoading" class="list-group-loading" data-test-key="ordered-games-loading">Loading games...</div>
        <div v-else-if="items.length === 0" class="list-group-empty" data-test-key="ordered-games-empty">No data available</div>
        <draggable class="list-group" :list="items" group="games" tag="ul" handle=".icon" data-test-key="ordered-games">
          <li class="list-group-item" v-for="(game, index) in items" :key="index">
            {{ game.name }}
            <v-icon v-if="canDrag" class="icon right">open_with</v-icon>
          </li>
        </draggable>

        <div class="d-inline-flex pt-2">
          <luci-btn-icon :config="saveBtn" @callback="saveOrder"></luci-btn-icon>
          <luci-btn-icon :config="resetBtn" @callback="resetOrder"></luci-btn-icon>
        </div>
      </v-flex>

      <v-flex md6>
        <div class="list-group-header" data-test-key="all-games-title">All Games</div>
        <div v-if="isLoadingGames" class="list-group-loading" data-test-key="all-games-loading">Loading games...</div>
        <div v-else-if="getGames.length === 0" class="list-group-empty" data-test-key="all-games-empty">No data available</div>
        <draggable class="list-group" :list="getGames" group="games" tag="ul" handle=".icon" data-test-key="all-games">
          <li class="list-group-item" v-for="(game, index) in getGames" :key="index">
            {{ game.name }}
            <v-icon v-if="canDrag" class="icon right">open_with</v-icon>
          </li>
        </draggable>
      </v-flex>
    </v-layout>

    <message-modal :open="showMsgModal" :title="'Unable to save/reset'" :message="'Please select a valid category/territory'" @ok-callback="showMsgModal = false"></message-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters, mapActions } from 'vuex'

import MessageModal from '../modal/MessageModal'

export default {
  components: { draggable, MessageModal },
  computed: {
    ...mapGetters({
      error: 'gameOrder/list/error',
      items: 'gameOrder/list/items',
      isLoading: 'gameOrder/list/isLoading',
      view: 'gameOrder/list/view',
      getCategories: 'gameOrder/list/getCategories',
      getTerritories: 'gameOrder/list/getTerritories',
      getGames: 'gameOrder/list/getGames',
      isLoadingGames: 'gameOrder/list/isLoadingGames'
    }),
    categories () {
      return {
        name: 'category',
        label: 'category',
        selectConfig: { items: this.getCategories }
      }
    },
    territories () {
      return {
        name: 'territory',
        label: 'territory',
        selectConfig: { items: this.getTerritories }
      }
    },
    canDrag () {
      return this.selectedCategory && this.selectedTerritory
    }
  },
  data () {
    return {
      showMsgModal: false,
      selectedCategory: null,
      selectedTerritory: null,
      saveBtn: { name: 'save-btn', primary: true, type: 'button', icon: true, iconType: 'save', tooltip: 'Save order' },
      resetBtn: { name: 'reset-btn', primary: false, type: 'button', icon: true, iconType: 'reset', tooltip: 'Reset order' }
    }
  },
  created () {
    this.resetOrderedGames()
    this.getAllCategories()
    this.getAllTerritories()
    this.getAllGames()
  },
  methods: {
    ...mapActions({
      getAllCategories: 'gameOrder/list/getAllCategories',
      getAllTerritories: 'gameOrder/list/getAllTerritories',
      getAllGames: 'gameOrder/list/getAllGames',
      getOrderedGames: 'gameOrder/list/getOrderedGames',
      saveOrderedGames: 'gameOrder/list/saveOrderedGames',
      resetOrderedGames: 'gameOrder/list/resetOrderedGames'
    }),
    changeCategory (value) {
      if (value) {
        this.selectedCategory = value
      } else {
        this.selectedCategory = null
        this.resetOrderedGames()
      }

      if (this.selectedCategory && this.selectedTerritory) {
        this.getOrderedGames({ categoryId: this.selectedCategory, territorySlug: this.selectedTerritory })
      }
    },
    changeTerritory (value) {
      if (value) {
        this.selectedTerritory = value
      } else {
        this.selectedTerritory = null
        this.resetOrderedGames()
      }

      if (this.selectedCategory && this.selectedTerritory) {
        this.getOrderedGames({ categoryId: this.selectedCategory, territorySlug: this.selectedTerritory })
      }
    },
    saveOrder () {
      if (this.selectedCategory && this.selectedTerritory) {
        this.saveOrderedGames({
          categoryId: this.selectedCategory,
          territorySlug: this.selectedTerritory,
          gameList: this.items
        })
      } else {
        this.showMsgModal = true
      }
    },
    resetOrder () {
      if (this.selectedCategory && this.selectedTerritory) {
        this.getOrderedGames({ categoryId: this.selectedCategory, territorySlug: this.selectedTerritory })
      } else {
        this.showMsgModal = true
      }
    }
  }
}
</script>
